import { Command } from 'commands/Commands';

export class ChangeMemberLinkedInVisibility extends Command {
  type: string = 'Member.ChangeLinkedInVisibility';
  priority = 100;
}
